import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import MessageFormValidate from "../MessageFormValidate";
import "./style.scss";
const InputChips = props => {
  const { defaultMails, handleSelectMail } = props;

  const [chips, setChips] = useState({
    items: defaultMails,
    value: "",
    error: null,
  });

  useEffect(() => {
    if (chips) {
      handleSelectMail(chips.items);
    }
  }, [chips]);

  const handleKeyDown = evt => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();

      var value = chips.value.trim();

      if (value && isValid(value)) {
        setChips({
          ...chips,
          items: [...chips.items, chips.value],
          value: "",
        });
      }
    }
  };

  const handleChange = evt => {
    setChips({
      ...chips,
      value: evt.target.value,
      error: null,
    });
  };

  const handleDelete = item => {
    setChips({
      ...chips,
      items: chips.items.filter(i => i !== item),
    });
  };

  const handlePaste = evt => {
    evt.preventDefault();

    var paste = evt.clipboardData.getData("text");
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

    if (emails) {
      var toBeAdded = emails.filter(email => !isInList(email));

      setChips({
        ...chips,
        items: [...chips.items, ...toBeAdded],
      });
    }
  };

  const isValid = email => {
    let error = null;

    if (isInList(email)) {
      error = `${email} đã được thêm.`;
    }

    if (!isEmail(email)) {
      error = `${email} không hợp lệ.`;
    }

    if (error) {
      setChips({ ...chips, error });
      return false;
    }

    return true;
  };

  const isInList = email => {
    return chips.items.includes(email);
  };

  const isEmail = email => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  };

  return (
    <div className="input-chip">
      <div className="font-size-16">
        Từ:{" "}
        <strong style={{ color: "gray" }}>
          Hệ thống 4si E-invoice - Thông báo
        </strong>
      </div>
      <div className="mt-2 d-flex">
        <span
          className="font-size-16 "
          style={{ marginRight: "4px", marginTop: "2px" }}
        >
          Tới:
        </span>
        <div>
          {chips.items.map(item => (
            <div className="font-size-14 tag-item" key={item}>
              {item}
              <button
                type="button"
                className="button"
                onClick={() => handleDelete(item)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      </div>

      <input
        className={"mt-2 form-control " + (chips.error && "is-invalid")}
        value={chips.value}
        placeholder="Nhập mail khách hàng và nhấn `Enter` ..."
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onPaste={handlePaste}
      />

      {chips.error && <MessageFormValidate error={chips.error} />}
    </div>
  );
};

export default InputChips;

InputChips.propTypes = {
  handleSelectMail: PropTypes.func,
  defaultMails: PropTypes.array,
};
